import { reducerWithInitialState } from 'typescript-fsa-reducers/dist';
import { noop } from '../../utils/utils';
import { Claims } from 'its-pages';
import {
  firebaseInitialized,
  initAuthUnsubscribeAction,
  setStudentRoleOverride,
  updateAuthUserAction,
  updateCurrentUser,
  updateCurrentUserUnsubscribe,
} from '../actions/firebase-actions';
import { Firebase } from '../../remote/firebase';
import { ITSUser } from '../../types/user';

export type AuthUser = {
  firebaseUser: firebase.User | null;
  claims?: Claims;
} | null;

export interface FirebaseState {
  initialized: boolean;
  firebase: Firebase | null;
  authUser: AuthUser;
  authUnsubscribe: firebase.Unsubscribe;
  newUser: boolean;
  currentUser?: ITSUser;
  currentUserUnsubscribe: firebase.Unsubscribe;
  studentRoleOverride: boolean;
}

const INITIAL_STATE: FirebaseState = {
  initialized: false,
  firebase: null,
  authUser: null,
  newUser: false,
  authUnsubscribe: noop,
  currentUserUnsubscribe: noop,
  studentRoleOverride: false,
};

function updateAuthUserReducer(
  state: FirebaseState,
  authUser: AuthUser
): FirebaseState {
  return {
    ...state,
    authUser,
    newUser: !authUser?.claims?.role,
  };
}

function initAuthUnsubscribeReducer(
  state: FirebaseState,
  authUnsubscribe: firebase.Unsubscribe
): FirebaseState {
  return {
    ...state,
    authUnsubscribe,
  };
}

function firebaseInitializedReducer(
  state: FirebaseState,
  firebase: Firebase
): FirebaseState {
  return {
    ...state,
    firebase,
    initialized: true,
  };
}

function updateCurrentUserReducer(
  state: FirebaseState,
  currentUser: ITSUser | undefined
): FirebaseState {
  return {
    ...state,
    currentUser,
  };
}

function updateCurrentUserUnsubscribeReducer(
  state: FirebaseState,
  currentUserUnsubscribe: firebase.Unsubscribe
): FirebaseState {
  return {
    ...state,
    currentUserUnsubscribe,
  };
}

function setStudentRoleOverrideReducer(
  state: FirebaseState,
  studentRoleOverride: boolean
): FirebaseState {
  return {
    ...state,
    studentRoleOverride,
  };
}

export const firebaseReducers = reducerWithInitialState(INITIAL_STATE)
  .case(firebaseInitialized, firebaseInitializedReducer)
  .case(updateAuthUserAction, updateAuthUserReducer)
  .case(initAuthUnsubscribeAction, initAuthUnsubscribeReducer)
  .case(updateCurrentUser, updateCurrentUserReducer)
  .case(setStudentRoleOverride, setStudentRoleOverrideReducer)
  .case(updateCurrentUserUnsubscribe, updateCurrentUserUnsubscribeReducer)
  .build();
